export enum STORE_ACTION {
    InitConfig = "initConfig",
    AddPrevMessages = "addPrevMessages",
    RefreshToken = "refreshToken",
    CallAutoRefresh = "callAutoRefresh",
}
